export default {
  // Cookies page
  cookiesTitle: 'Cookie policy & settings',
  cookiesIntro:
    'PlayStock uses cookies and similar technologies to keep the site stable and secure, enhance your experience, and analyze how the platform is used. Manage your preferences below.',
  cookiesPrefsTitle: 'Your preferences',
  cookiesRowEssential: 'Essential',
  cookiesRowEssentialDesc: 'Required for core operations, authentication, and security. Cannot be disabled.',
  cookiesRowAnalytics: 'Analytics',
  cookiesRowAnalyticsDesc: 'Helps us understand traffic patterns, optimize performance, and improve navigation flow.',
  cookiesRowMarketing: 'Marketing',
  cookiesRowMarketingDesc: 'Used to deliver targeted promotional content and track campaign performance across networks.',
  cookiesSaved: 'Preferences saved.',
  cookiesSave: 'Save preferences',

  cookiesInUseTitle: 'Cookies in use',
  cookiesColName: 'Name',
  cookiesColProvider: 'Provider',
  cookiesColPurpose: 'Purpose',
  cookiesColType: 'Type',
  cookiesColExpiry: 'Expiry',

  cookiesGroupEssential: 'Essential (strictly necessary)',
  cookiesGroupAnalytics: 'Analytics & performance',
  cookiesGroupMarketing: 'Marketing & targeting',

  cookieSessionPurpose: 'Maintains active user session state.',
  cookieCsrfPurpose: 'Prevents Cross-Site Request Forgery attacks.',
  cookieGaPurpose: 'Distinguishes unique users for traffic analysis.',
  cookiePerfPurpose: 'Monitors terminal load times and latency.',
  cookieFbpPurpose: 'Tracks conversions and targets ad delivery.',

  cookieExpirySession: 'Session',
  cookieExpiry1Day: '1 Day',
  cookieExpiry2Years: '2 Years',
  cookieExpiryPersistent: 'Persistent',
  cookieExpiry3Months: '3 Months',
  cookieTypeHttp: 'HTTP',
  cookieTypeLocalStorage: 'HTML5 Local Storage',

  cookiesNotes:
    'Changing these settings may require a page reload to fully take effect. For a complete overview of how we handle your data, please review our full policy.',
  cookiesReadFullPolicy: 'Read full privacy policy',

  // Terms page
  termsTitle: 'Terms & Conditions',
  termsLastUpdated:
    'Last updated: 24 October 2026. Welcome to PlayStock. Please read these terms carefully before using the platform.',
  termsToc: 'Table of contents',
  termsNeedAssistanceTitle: 'Need assistance?',
  termsNeedAssistanceBody: 'If you have questions about these terms, our support team is here to help.',
  termsContactSupport: 'Contact support',

  termsS1Title: 'Acceptance of Terms',
  termsS1P1:
    'By accessing or using the PlayStock platform, you agree to be bound by these Terms and Conditions and all applicable laws and regulations. If you do not agree with any part of these terms, you are prohibited from using or accessing this site.',
  termsS1P2:
    'These terms establish a binding legal agreement between you and PlayStock. We reserve the right to modify these terms at any time. Your continued use of the platform following the posting of changes will mean that you accept and agree to the changes.',

  termsS2Title: 'Account Registration',
  termsS2P1:
    'To access certain features of the platform, you must register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.',
  termsS2P2:
    'You are solely responsible for safeguarding the password that you use to access your account and for any activities or actions under your password. PlayStock will not be liable for any loss or damage arising from your failure to comply with these security obligations.',

  termsS3Title: 'Purchases and Payments',
  termsS3P1:
    'All prices are shown in EUR unless otherwise noted. We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel quantities purchased per person, per household, or per order.',
  termsS3P2:
    'You agree to provide current, complete, and accurate purchase and account information for all purchases. In the event that we change or cancel an order, we may attempt to notify you by contacting the e-mail provided at the time the order was made.',

  termsS4Title: 'Digital Key Delivery',
  termsS4P1:
    'Products sold on PlayStock are digital activation keys delivered electronically. Once your payment has cleared, the key is made available in your account under “My Orders”, typically within seconds.',
  termsS4P2:
    'You are responsible for activating your key on the correct platform (e.g. Steam, Epic Games) and for reviewing any regional restrictions shown on the product page prior to purchase.',

  termsS5Title: 'Refund Policy',
  termsS5P1:
    'Because digital keys are non-recoverable once revealed, refunds are only available for keys that have not been revealed or activated. Revealing a key constitutes consumption of the digital product and waives the right of withdrawal.',
  termsS5P2:
    'If a key is faulty or cannot be activated for reasons attributable to PlayStock, contact our support team and we will investigate and, where appropriate, issue a replacement or refund.',

  termsS6Title: 'User Conduct',
  termsS6P1:
    'You agree not to use the platform for any unlawful purpose, to resell keys obtained in breach of these terms, to attempt to circumvent security or rate-limiting controls, or to interfere with the normal operation of the service.',
  termsS6P2:
    'We reserve the right to suspend or terminate accounts that violate these terms or that we reasonably believe are engaged in fraudulent or abusive activity.',

  termsS7Title: 'Intellectual Property',
  termsS7P1:
    'All content on the platform, including text, graphics, logos, and software, is the property of PlayStock or its licensors and is protected by applicable intellectual-property laws. Game titles, artwork, and trademarks remain the property of their respective owners.',

  termsS8Title: 'Limitation of Liability',
  termsS8P1:
    'To the maximum extent permitted by law, PlayStock shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of the platform, even if advised of the possibility of such damages.',

  termsS9Title: 'Governing Law',
  termsS9P1:
    'These terms are governed by and construed in accordance with the laws of Latvia, and you submit to the non-exclusive jurisdiction of the courts located there for the resolution of any disputes.',

  termsS10Title: 'Contact',
  termsS10P1:
    "Questions about these Terms & Conditions can be directed to our support team at support{'@'}playstock.red.",
};
